export default {
  entity: {
    history: 'Historique',
    type: {
      UPDATE: 'Mise à jour',
      INITIAL: 'Création',
    },
    locked: 'Cet élément est modifié par {0}',
    lockedByYou: 'Vous verrouillez cette entité',
    lockedTwice: 'Vous verrouillez cette entité dans un autre onglet',
  },
}
